<template>
	<div class="info-cls">
		<div class="describe-cls">
			当前位置：
			<span v-if="qaDetail.parentNode" v-for="(v, i) in qaDetail.parentNode" :key="i">
				{{v.name}}
				<i v-show="i+1 !== qaDetail.parentNode.length"> / </i>
			</span>
		</div>
		<div class="process-cls">
			<div class="cell" :class="{'active': activeId === item.id}" v-for="(item, index) in list" :key="index">
				<i @click.stop="handleSwitch(item, index)">{{index+1}}</i>
				<div class="title">{{item.name}}</div>
				<div class="speak" v-if="item.isSpeak">
					<svg-icon icon-class="Knowxz" style="margin-right: 5px; color: #337EFF;font-size: 18px" />
					<span style="color: #337EFF">推荐话术：</span>
					<span>{{item.speak}}</span>
				</div>
				<div v-html="item.welfareText"></div>
				<div class="welfare" v-if="item.isOption">
					<svg-icon icon-class="Knowkr" style="margin-right: 5px; color: #47b267; font-size: 16px" />
					<span style="color: #47b267">回答：</span>
					<el-radio-group v-model="item.value" @change="(ev) => { return handleNext(ev, index)}" :disabled="activeId !== item.id">
						<el-radio v-for="(_item, _index) in item.optionList" :key="_index" :label="_item.nextId">{{_item.name}}</el-radio>
					</el-radio-group>
				</div>
				<div class="btns" v-if="!item.isOption && count !== themeList.length && item.nextId">
					<el-button size="mini" @click.stop="handleNext(item.nextId, index)" :disabled="activeId !== item.id">下一步</el-button>
				</div>
				<div class="speak" v-if="!item.isOption && !item.nextId">结束流程</div>
			</div>
		</div>
		<section class="help-cls">
			<span>有帮助？ <svg-icon :class="{'agree': qaDetail.helpType === 'agree'}" @click.stop="handleHelp(qaDetail, true, 'detail')" style="margin-left: 12px" icon-class="Agree" />  <svg-icon style="margin-left: 16px" :class="{'no-agree': qaDetail.helpType === 'no-agree'}" @click.stop="handleHelp(qaDetail, index, false, 'detail')" icon-class="NoAgree" /></span>
			<span>有帮助：{{qaDetail.help}}</span>
			<span>查看量：{{qaDetail.click}}</span>
			<span>最近修改时间：{{qaDetail.lastUpdateTime | formatDate}}</span>
		</section>
		<div class="associated-cls" v-if="sourceList[sjs]">
			<div class="title-cls">相关流程</div>
			<div class="btns-cls">
				<el-button @click.stop="handleBigScreenInfo(sourceList[sjs])" type="primary" size="mini" plain round>{{sourceList[sjs]['q']}}</el-button>
				<!-- <el-button v-if="list.length > 1" @click.stop="handleBigScreenInfo(sourceList[sjs === 6 ? sjs - 1 : sjs + 1])" type="primary" size="mini" plain round>{{sourceList[sjs === 6 ? sjs - 1 : sjs + 1]['q']}}</el-button> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'KnowledgeInfo',
	props: ['qaDetail', 'sourceList', 'sjs'],
	data() {
		return {
			currentIndex: '',
			activeId: '',
			list: [],
			themeList: [],
			isClear: false,
			count: 1
		}
	},
	watch: {
		qaDetail: {
			handler() {
				this.themeList = JSON.parse(this.qaDetail?.a)?.themeList;
				this.list = [this.themeList[0]];
				this.activeId = this.themeList[0]['id']
			},
			immediate:true,
			deep: true
		},
	},
	methods: {
		handleBigScreenInfo(item) {
			this.$emit('emitScreenInfo', item, 'process');
		},
		handleSwitch(item, index) {
			if(item.id === this.activeId) return;
			this.currentIndex = index;
			this.activeId = item.id;
			this.isClear = true;
		},
		handleNext(e, index) {
			if(this.isClear){
				this.isClear = false;
				this.list = this.list.splice(0, this.currentIndex+1);
				this.count = this.currentIndex+1;
				setTimeout(() => {
					this.currentIndex = index;
					this.activeId = e;
					this.count = this.count += 1;
					for(const item of this.themeList) {
						if(e === item.id) {
							this.list.push(item);
						}
					}
				}, 100);
			} else {
				setTimeout(() => {
					this.currentIndex = index;
					this.activeId = e;
					this.count = this.count += 1;
					for(const item of this.themeList) {
						if(e === item.id) {
							this.list.push(item);
						}
					}
				}, 100);
			}
		},
		handleHelp(item, type) {
			const self = this;
			if(item.isHelp) return;
			item['isHelp'] = true;
			item['helpType'] = type ? 'agree' : 'no-agree';
			Vue.set(self.qaDetail, item);
			self.$api.apiPostKnowledgeSetHelp({
				projectId: self.qaDetail.projectId,
				id: item.id,
				type: type ? 1 : 2
			});
		},
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
	& span {
		font-size: 16px;
	}
}
.info-cls {
	width: 100%;
	padding: 20px;
	height: 100%;
	box-sizing: border-box;
	
	& > .process-cls {
		width: 100%;
		margin-bottom: 20px;
		

		& > .cell {
			width: 100%;
			padding-left: 34px;
			box-sizing: border-box;
			position: relative;
			margin-bottom: 10px;

			&::before {
				content: "";
				width: 1px;
				height: 100%;
				background: #c8c9cc;
				position: absolute;
				top: 24px;
				left: 12px;
			}

			&:last-child::before {
				display: none;
			}

			& > i {
				display: inline-block;
				text-align: center;
				font-style: normal;
				width: 24px;
				height: 24px;
				background: #c8c9cc;
				color: #fff;
				font-size: 14px;
				line-height: 24px;
				border-radius: 50%;
				position: absolute;
				top: 0;
				left: 0;
				cursor: pointer;
			}

			&.active {
				&::before {
					// background: #337EFF;
				}

				& > i {
					background: #337EFF;
				}
			}

			& > .title {
				font-size: 14px;
				font-weight: bold;
				color: #3C4353 ;
				line-height: 24px;
				margin-bottom: 16px;
			}

			& > .speak {
				font-size: 16px;
				font-weight: 400;
				color: #6C7E91;
				line-height: 24px;
				margin-bottom: 16px;
			}

			& > .welfare {
				margin-bottom: 16px;
				& > span {
					font-size: 16px;
					font-weight: 400;
					color: #6C7E91;
					line-height: 24px;
				}
			}

			& .btns {
				margin-top: 13px;
			}
		}
	}

	& > .help-cls {
		border-bottom: 1px solid #efefef;
		margin-bottom: 10px;
		width: 100%;
		height: 24px;
		font-size: 12px;
		font-weight: 400;
		color: #A6AAB8;
		line-height: 24px;
		text-align: right;
		padding-bottom: 35px;
		box-sizing: border-box;

		& > span:nth-of-type(1) {
			float: left;
			margin: 0;
		}

		& > span {
			margin-left: 15px;
		}
		
		& .svg-icon {
			cursor: pointer;

			&.agree {
				color: #f29521;
			}

			&.no-agree {
				color: #ff504d;
			}
		}
	}

	& > .associated-cls {
		width: 100%;
		margin-bottom: 20px;

		& > .title-cls {
			font-size: 12px;
			font-weight: 400;
			color: #337EFF;
			font-weight: 500;
			line-height: 24px;
			margin-bottom: 5px;
		}

		& > .btns-cls {
			width: 100%;
			height: 24px;
			margin-bottom: 12px;

			& .el-button {
				background: #fff;
				height: 24px;
				line-height: 24px;
				padding: 0 15px;
				box-sizing: border-box;
				font-size: 12px;
				color: #337EFF;
			}
		}
	}
	& > .describe-cls {
		font-size: 12px;
		font-weight: 400;
		color: #6C7E91;
		line-height: 24px;
		box-sizing: border-box;
		margin-bottom: 16px;
		padding-left: 10px;
		box-sizing: border-box;
		font-weight: 900;

		& > p {
			line-height: 20px;
			margin-bottom: 3px;

			& > span {
				margin-right: 20px;
				font-weight: 900;

				&:nth-of-type(3) {
					float: right;
					margin: 0;
				}
			}
		}
	}
}
</style>